import { getThumbBaseUrl } from "store/static";

export const getRethumbUrl = (
  width,
  height,
  imageUrl,
  widthScaleFactor,
  heightScaleFactor,
  fitIn = false
) => {
  const finalWidth = Math.round(widthScaleFactor * width);
  const finalHeight = Math.round(heightScaleFactor * height);
  if (fitIn) {
    return `${getThumbBaseUrl()}fit-in/${finalWidth}x${finalHeight}/${imageUrl}`;
  } else {
    return `${getThumbBaseUrl()}${finalWidth}x${finalHeight}/${imageUrl}`;
  }
};
